import ActiveSectionsData from './ActiveSectionsData'

export default ActiveSectionsData
